import { render, staticRenderFns } from "./Series.vue?vue&type=template&id=bf606026&scoped=true"
import script from "./Series.vue?vue&type=script&lang=js"
export * from "./Series.vue?vue&type=script&lang=js"
import style0 from "./Series.vue?vue&type=style&index=0&id=bf606026&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf606026",
  null
  
)

export default component.exports